import React from "react";
import { STATUS_LABELS, STATUS_STYLES } from "../lib/constants";

export const StatusPill = ({ status, testId }) => (
  <span
    data-testid={testId || `status-${status}`}
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium border ${STATUS_STYLES[status] || STATUS_STYLES.paid}`}
  >
    <span className="w-1.5 h-1.5 rounded-full bg-current" />
    {STATUS_LABELS[status] || status}
  </span>
);

export default StatusPill;
